<template>
    <BaseModal
        v-model="open"
        size="md">
        <div class="sm:flex sm:items-start">
            <div
                class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-primary-100 sm:mx-0 sm:h-10 sm:w-10">
                <Icon
                    name="heroicons:information-circle"
                    class="h-6 w-6 text-primary-600"
                    aria-hidden="true" />
            </div>
            <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                <DialogTitle
                    as="h3"
                    class="text-base font-semibold leading-6 text-gray-900">
                    {{ $t('mails.resendMail') }}
                </DialogTitle>
                <div class="mt-2">
                    <p class="text-sm text-gray-500 dark:text-gray-200 mb-2">
                        {{ $t('mails.resendMailDescription') }}
                    </p>
                </div>
            </div>
        </div>
        <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-2">
            <BaseButton
                color="primary"
                :disabled="loading"
                @click="resendMail">
                <span
                    v-if="loading">
                    <LoadingSpinner />
                </span>
                <span v-else>
                    {{ $t('mails.resendMail') }}
                </span>
            </BaseButton>
            <BaseButton
                @click="open = false">
                {{ $t('abort') }}
            </BaseButton>
        </div>
    </BaseModal>
</template>

<script setup>
import {useNotification} from "@/composables/useNotification"
import { useAuthStore } from '@/store/auth'
import {$lara} from "@/utils/$larafetch"
const {$apiRoute} = useNuxtApp()

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    mail: {
        type: [Object, null],
        required: true
    }
})

const {t: $t} = useI18n()
const authStore = useAuthStore()
const email = ref('')
const loading = ref(false)

const emits = defineEmits(['update:modelValue', 'resent'])

const open = computed({
    get: () => props.modelValue,
    set: (value) => emits('update:modelValue', value)
})

onMounted(() => {
    if (authStore.userData.email) {
        email.value = authStore.userData.email
    }
})

function resendMail() {
    loading.value = true

    const notification = useNotification()

    $lara.post($apiRoute('spa.basedata.mails.resend', {mail: props.mail.id}), {
    }).then((response) => {
        loading.value = false
        notification.success($t('mails.resendMailSuccess'))

        emits('resent')
        open.value = false
    }).catch((error) => {
        loading.value = false
        notification.error($t('mails.resendMailFailed'), error?.data?.message)

        open.value = false
    })
}
</script>